// frontend/src/App.jsx (UPDATED)

import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const BlockedNumbersPage = lazy(() => import("./pages/BlockedNumbersPage"));
const ExtSubscriptionsPage = lazy(() => import("./pages/ExtSubscriptionsPage"));
const RateLimitStatsPage = lazy(() => import("./pages/RateLimitStatsPage"));
const RateLimitHistoryPage = lazy(() => import("./pages/RateLimitHistoryPage"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const SecurityPage = lazy(() => import("./pages/SecurityPage"));
const PaymentsPage = lazy(() => import("./pages/PaymentsPage"));
const SessionsPage = lazy(() => import("./pages/SessionsPage"));
const routeFallback = (
  <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>
    Loading...
  </div>
);

export default function App() {
  return (
    <Suspense fallback={routeFallback}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/blocked-numbers"
          element={
            <ProtectedRoute requiredRole="system_owners">
              <BlockedNumbersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ext-subscriptions"
          element={
            <ProtectedRoute requiredRole="system_owners">
              <ExtSubscriptionsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/rate-limit-stats"
          element={
            <ProtectedRoute requiredRole={["system_owners", "admin"]}>
              <RateLimitStatsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/rate-limit-history"
          element={
            <ProtectedRoute requiredRole={["system_owners", "admin"]}>
              <RateLimitHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute requiredRole={["system_owners", "admin"]}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/security"
          element={
            <ProtectedRoute requiredRole={["system_owners", "admin"]}>
              <SecurityPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute requiredRole={["system_owners", "admin"]}>
              <PaymentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sessions"
          element={
            <ProtectedRoute requiredRole={["system_owners", "admin"]}>
              <SessionsPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
